import Box from '@mui/material/Box';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { Divider } from '@katalon-studio/katalon-ui/v2';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import makeStyles from '@mui/styles/makeStyles';
import { Panel } from '../../../../components/common/Panel';
import { ContactSaleBtn } from '../../../../components';
import { TrackingPayload } from '../../../../utils/utils';

const CONTACT_SALES_URL = 'https://katalon.com/contact-us#contact-us';

const useStyles = makeStyles(theme => ({
  enterprisePanel: {
    width: 290,
    border: '2px solid #5959EB',
    borderRadius: 8,
    padding: theme.spacing(2.5),
    backgroundColor: '#fff',
    flexShrink: 0,
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },
  },
  enterprisePanelHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  enterpriseIconCircle: {
    width: 40,
    height: 40,
    borderRadius: 8,
    background: 'linear-gradient(90deg, #5959EB 0%, #9B59EB 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  enterprisePanelTitle: {
    fontWeight: 700,
    fontSize: 16,
    color: '#22283C',
  },
  enterprisePanelSubtitle: {
    fontSize: 13,
    color: '#808B9A',
  },
  enterpriseFeatureRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    margin: theme.spacing(3, 1),
  },
  enterpriseFeatureIcon: {
    color: '#5959EB',
    fontSize: 20,
  },
  enterpriseFeatureText: {
    fontSize: 14,
    color: '#22283C',
  },
  talkToSalesBtn: {
    marginTop: theme.spacing(2),
    width: '100%',
    background: 'linear-gradient(90deg, #5959EB 0%, #9B59EB 100%)',
    color: '#fff',
    fontWeight: 700,
    fontSize: 14,
    borderRadius: 8,
    padding: theme.spacing(1.5),
    textTransform: 'none' as const,
    '&:hover': {
      background: 'linear-gradient(90deg, #43509B 0%, #7B43CB 100%)',
    },
  },
}));

export const TrueEnterprise = (
  { trackSubscriptionAction }: {
    trackSubscriptionAction?: (payload: TrackingPayload) => void,
  },
) => {
  const classes = useStyles();

  return (
    <Panel
      id="true-enterprise-upsell-panel"
      sx={theme => ({
        width: '100%',
        minWidth: 0,
        height: '100%',
        borderTop: '8px solid #5959EB',
        boxShadow: '0 0 0 4px rgba(91,95,199,0.09), 0 4px 20px rgba(91,95,199,0.10)',
        borderRadius: 3,
        '& > .MuiPaper-root': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
        [theme.breakpoints.down('tabletL')]: {
          width: '100%',
        },
      })}
    >
      <Box padding={4}>
        <Box className={classes.enterprisePanelHeader}>
          <Box className={classes.enterpriseIconCircle}>
            <StarBorderOutlinedIcon sx={{ color: '#ffffff', fontSize: 22 }} />
          </Box>
          <Box>
            <Typography className={classes.enterprisePanelTitle}>
              <FormattedMessage id="page.subscription.v2.true.enterprise.panel.title" />
            </Typography>
            <Typography className={classes.enterprisePanelSubtitle}>
              <FormattedMessage id="page.subscription.v2.true.enterprise.panel.subtitle" />
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box className={classes.enterpriseFeatureRow}>
          <LockOutlinedIcon className={classes.enterpriseFeatureIcon} />
          <Typography className={classes.enterpriseFeatureText}>
            <FormattedMessage id="page.subscription.v2.true.enterprise.panel.sso" />
          </Typography>
        </Box>
        <Box className={classes.enterpriseFeatureRow}>
          <PeopleAltOutlinedIcon className={classes.enterpriseFeatureIcon} />
          <Typography className={classes.enterpriseFeatureText}>
            <FormattedMessage id="page.subscription.v2.true.enterprise.panel.csm" />
          </Typography>
        </Box>
        <Box className={classes.enterpriseFeatureRow}>
          <ChatOutlinedIcon className={classes.enterpriseFeatureIcon} />
          <Typography className={classes.enterpriseFeatureText}>
            <FormattedMessage id="page.subscription.v2.true.enterprise.panel.support" />
          </Typography>
        </Box>
        <Box className={classes.enterpriseFeatureRow}>
          <SecurityOutlinedIcon className={classes.enterpriseFeatureIcon} />
          <Typography className={classes.enterpriseFeatureText}>
            <FormattedMessage id="page.subscription.v2.true.enterprise.panel.scim" />
          </Typography>
        </Box>

        <ContactSaleBtn
          className={classes.talkToSalesBtn}
          onClick={() => trackSubscriptionAction?.({
            field: 'true_enterprise_upsell',
            object: 'contact_sales',
            action: 'click',
            url: CONTACT_SALES_URL,
          })}
        />
      </Box>
    </Panel>
  );
};
